import { Link } from 'react-router-dom';
import { Navigation } from './Navigation';
import { useMobileMenu } from '@/shared/hooks/useMobileMenu';
import { useScrollHeader } from '@/shared/hooks/useScrollHeader';

interface HeaderProps {
  logoLight?: string;
  logoDark?: string;
  logoMobile?: string;
  variant?: 'default' | 'light-hero' | 'light';
}

export const Header = ({
  logoLight = '/images/logo-blue.png',
  logoDark = '/images/logo-blue-white.png',
  logoMobile = '/images/logo-blue.png',
  variant = 'default'
}: HeaderProps) => {
  const { isOpen, toggle, close } = useMobileMenu();
  const isScrolled = useScrollHeader();

  // Determine header classes based on variant
  const headerClasses =
    variant === 'light-hero'
      ? 'tra-menu navbar-dark light-hero-header white-scroll w-full block !pt-0'
      : 'tra-menu navbar-light inner-page-header white-scroll w-full block !pt-0';

  return (
    <header id="header" className={headerClasses}>
      <div className="header-wrapper fixed z-[1030] top-0 inset-x-0">
        {/* MOBILE HEADER */}
        <div className="wsmobileheader clearfix">
          <span className="smllogo md:max-lg:!block md:max-lg:!mt-[22px] md:max-lg:!pl-[22px] sm:max-md:!block sm:max-md:!mt-[23px] sm:max-md:!pl-[18px] xsm:max-sm:!block xsm:max-sm:!mt-[23px] xsm:max-sm:!pl-[16px]">
            <Link to="/">
              <img
                className="md:w-auto md:max-lg:!max-w-[inherit] md:max-lg:!max-h-[34px] sm:max-md:!w-auto sm:max-md:!max-w-[inherit] sm:max-md:!max-h-[34px] xsm:max-sm:!w-auto xsm:max-sm:!max-w-[inherit] xsm:max-sm:!max-h-[34px]"
                src={logoMobile}
                alt="mobile-logo"
              />
            </Link>
          </span>
          <button
            id="wsnavtoggle"
            className="wsanimated-arrow"
            onClick={toggle}
            aria-label="Toggle mobile menu"
          >
            <span></span>
          </button>
        </div>

        {/* NAVIGATION MENU */}
        <div
          className={`wsmainfull menu clearfix p-[20px_0] w-full h-auto z-[1031] [transition:all_450ms_ease-in-out] ${
            variant === 'light-hero' ? '!text-[#353f4f]' : '!text-[#b1b7cd]'
          } ${isScrolled ? 'scroll' : ''}`}
        >
          <div className="wsmainwp clearfix">
            {/* HEADER BLACK LOGO */}
            <div className="desktoplogo md:max-lg:!hidden">
              <Link to="/" className="logo-black">
                <img
                  className="light-theme-img w-auto max-w-[inherit] !max-h-[48px] lg:max-xl:!max-h-[34px] inline-block"
                  src={logoLight}
                  alt="logo"
                />
                <img
                  className="dark-theme-img w-auto max-w-[inherit] !max-h-[48px] lg:max-xl:!max-h-[34px]"
                  src={logoDark}
                  alt="logo"
                />
              </Link>
            </div>

            {/* HEADER WHITE LOGO */}
            <div className="desktoplogo md:max-lg:!hidden">
              <Link to="/" className="logo-white">
                <img
                  className="w-auto max-w-[inherit] !max-h-[48px] lg:max-xl:!max-h-[34px] inline-block"
                  src="/images/logo-white.png"
                  alt="logo"
                />
              </Link>
            </div>

            {/* MAIN MENU */}
            <Navigation
              onLinkClick={close}
              isScrolled={isScrolled}
              logoMobile={logoMobile}
            />
          </div>
        </div>
        {/* END NAVIGATION MENU */}

        {/* MOBILE MENU OVERLAY */}
        {isOpen && (
          <div
            className="overlapblackbg fixed inset-0 bg-black/50 z-[1029] md:max-lg:hidden"
            onClick={close}
          />
        )}
      </div>
      {/* End header-wrapper */}
    </header>
  );
};
